module.exports = __webpack_public_path__ + "img/icon-remove-red-bg.2a06b03f.svg";